import { render } from "./eventCreateModal.vue?vue&type=template&id=e748844c&scoped=true"
import script from "./eventCreateModal.vue?vue&type=script&lang=js"
export * from "./eventCreateModal.vue?vue&type=script&lang=js"

import "./eventCreateModal.vue?vue&type=style&index=0&id=e748844c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e748844c"]])

export default __exports__